import { ReactNode } from "react";

import textAreaStyles from "./TextArea.module.css";

interface TextAreaProps extends React.ButtonHTMLAttributes<HTMLInputElement> {
  children?: ReactNode; // Allows you to pass content to the button
}

export const Input: React.FC<TextAreaProps> = ({ children, ...props }) => {
  return (
    <input
      className={textAreaStyles.textArea}
      {...props}
      placeholder="Šta ima nova?"
    >
      {children}
    </input>
  );
};
